import { forwardRef } from "react";
import {
  Alert as MaterialAlert,
  AlertProps,
  Snackbar as MaterialSnackbar,
  AlertColor,
} from "@mui/material";
import { SnackbarProps } from "./types";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

const IconSeverityMap: Record<AlertColor, React.ReactNode> = {
  success: <CheckCircleOutlineOutlinedIcon />,
  error: <ErrorOutlineOutlinedIcon />,
  warning: <ErrorOutlineOutlinedIcon />,
  info: <CheckCircleOutlineOutlinedIcon />,
};

const Snackbar = ({
  open,
  message,
  severity,
  autoHideDuration,
  anchorOrigin,
  handleClose,
}: SnackbarProps) => {
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    { children, ...props },
    ref
  ) {
    return (
      <MaterialAlert
        ref={ref}
        icon={severity && IconSeverityMap[severity]}
        {...props}
      >
        {children}
      </MaterialAlert>
    );
  });

  return (
    <MaterialSnackbar
      autoHideDuration={autoHideDuration}
      anchorOrigin={anchorOrigin}
      open={open}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </MaterialSnackbar>
  );
};

export default Snackbar;
